$(document).on('turbo:load', function() {
  function fit_dependent_fields(dropdown_id, dependent_id_s, trigger_value_s, skip_show_dependent_ids = null) {
    const dependent_ids = Array.isArray(dependent_id_s) ? dependent_id_s : [dependent_id_s]
    const trigger_values = Array.isArray(trigger_value_s) ? trigger_value_s : [trigger_value_s]
    $(`#${dropdown_id}`).change(function () {
        for (const dependent_id of dependent_ids) {
            const dependent = $(`#${dependent_id}`);
            const required = !!dependent.find('.ff-required').length;
            const input = dependent.find('input, textarea, select');
            const value = $(this).val();
            if(Array.isArray(value) && value.some(v => trigger_values.includes(v)))
            {
                dependent.show();
            }
            else if (trigger_values.includes(value)) {
                if (skip_show_dependent_ids && skip_show_dependent_ids.includes(dependent_id)) return;
                dependent.show();
                if (required) input.prop('required', true);
            } else {
                dependent.hide();
                input.val(null).prop('required', false);
            }
        }
    });
  }

    function validate_field(id, error_message_id, limit, type = 'checkbox') {
        const $fields = $(`.${id}`);
        const $errorMsg = $(`.${error_message_id}`);

        if (type === 'checkbox') {
            const checkedCount = $fields.filter(':checked').length;
            if (checkedCount !== limit) {
                $errorMsg.text(`Please select ${limit} options and only ${limit} options.`).show();
            } else {
                $errorMsg.hide();
            }
            $fields.change(function () {
                const checkedCount = $fields.filter(':checked').length;
                if (checkedCount !== limit) {
                    $errorMsg.text(`Please select ${limit} options and only ${limit} options.`).show();
                } else {
                    $errorMsg.hide();
                }
            });
        }

        if (type === 'email') {
            function formatEmail() {
                const value = $(this).val();
                const emailRegex = /^[a-zA-Z0-9.!\#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                if (!emailRegex.test(value)) {
                    $errorMsg.text('Not a valid email address').show();
                } else {
                    $errorMsg.hide();
                }
            }
            $fields.each(function() {
                formatEmail.call(this);
            });
            $fields.on('keyup blur', function () {
                formatEmail.call(this);
            });
        }

        if (type === 'phone-number') {
            $fields.each(function() {
                const input = this;
                function formatPhoneAndValidate() {
                    let x = input.value.replace(/\D/g, '').slice(0, 10);
                    let formatted = x;
                    if (x.length > 6) {
                        formatted = `(${x.slice(0,3)}) ${x.slice(3,6)}-${x.slice(6)}`;
                    } else if (x.length > 3) {
                        formatted = `(${x.slice(0,3)}) ${x.slice(3)}`;
                    } else if (x.length > 0) {
                        formatted = `(${x}`;
                    }
                    input.value = formatted;


                    if (x.length > 0 && x.length < 10) {
                        $errorMsg.text('Phone number must be 10 digits').show();
                    }
                    else {
                        $errorMsg.hide();
                    }
                }
                input.addEventListener('input', formatPhoneAndValidate);
                formatPhoneAndValidate();
            });
        }
    }


    validate_field('email-js', 'email-error-js', 0, 'email')

    validate_field('phone-number-js', 'phone-number-error-js', 0, 'phone-number')

  // Background:
  // Have you owned a business before?
  fit_dependent_fields('owned-a-business', 'describe-the-business', ['Yes - Independent Business', 'Yes - Franchise', 'Yes - Both']);
  // Marital Status
  fit_dependent_fields('marital-status', ['married', 'employed-spouse'], 'Married', ['employed-spouse']);
  // Is your Spouse Employed?
  fit_dependent_fields('spouse-employed', 'employed-spouse', 'true');
  // Are you a US Citizen?
  fit_dependent_fields('us-citizen', ['e2-visa', 'e2-visa-text'], 'Other (Please Specify)');

  // Money:
  // Does your household have income from other sources that you will use for daily living?
  fit_dependent_fields('other-income', 'total-other-income', 'true');
  // Approximate Home Equity
  fit_dependent_fields('home-ownership-status', 'approximate-home-equity', ['Own Outright', 'Mortgage']);


  fit_dependent_fields('franchising-worries',
      'franchising-worries-more-info',
      'Other');

  fit_dependent_fields('home-ownership-status', 'approximate-home-equity', ['Own Outright', 'Mortgage']);



    fit_dependent_fields(
        'attractions-to-owning-own-business', // dropdown id
        'attractions-to-owning-own-business-more-info', // dependent field id
        ['Pursuing financial independence and greater control over professional outcomes',
            'Seeking supplemental or passive income opportunities, including long-term retirement planning',
            'Interested in business or franchise ownership opportunities',
            'Looking to expand or diversify an existing business portfolio',
            'Exploring the development of additional or recurring revenue streams',
            'Preferring a proven business model with established systems, support, and demonstrated performance']
        // or the values that should trigger showing the field
    );

  fit_dependent_fields(
        'franchise-vs-independent', // dropdown id
        'franchise-vs-independent-more-info', // dependent field id
        ['Pursuit of financial independence and improved work–life flexibility',
            'Interest in generating supplemental or passive income to enhance long-term financial security',
            'Desire to own, operate, or transition into business or franchise ownership',
            'Intent to expand, diversify, or scale an existing business or investment portfolio',
            'Focus on building additional, recurring, or scalable revenue streams',
            'Preference for established, proven business models with operational support and reduced risk']
        // or the values that should trigger showing the field
    );
  // Change colors of active Radio buttons in Franchise Fit form
  $('.ff-select-button input[type=radio]').click(function() {
      const radioGroup = $(`input:radio[name="${$(this).attr('name')}"]`)
      radioGroup.closest('.bin-wrapper').removeClass('active');
      $(this).closest('.bin-wrapper').addClass('active');
  });

  $('.ff-select-button input[type=checkbox]').click(function() {
      // Change colors of active Checkbox buttons in Franchise Fit form
      const binWrapper = $(this).closest('.bin-wrapper');
      if ($(this).is(':checked')) binWrapper.addClass('active');
      else binWrapper.removeClass('active')

      // Make only one checkbox required in a multiple group
      const parent = $(this).closest('.ff-required');
      if (parent.length) {
          const checkedCount = parent.find('input[type=checkbox]:checked').length;
          if (checkedCount) {
              parent.find('input[type=checkbox]').prop('required', false);
              parent.find('input[type=checkbox]').each(function() {
                  this.setCustomValidity('');
              });
          }
          else parent.find('input[type=checkbox]').prop('required', true);
      }
  });

  $('.franchise-fit-form .show-required-fields-btn').click(function() {
      const parent = $(this).closest('.franchise-fit-form');
      const requiredFields = parent.find('.ff-required');
      requiredFields.removeClass('ff-required-active');
      requiredFields.filter(function() {
          if ($(this).find('input[type=radio]').length) return !$(this).find('input[type=radio]:checked').val();
          else if ($(this).find('input[type=checkbox]').length) return !$(this).find('input[type=checkbox]:checked').val();
          else return !$(this).find('input, textarea, select').val();
      }).addClass('ff-required-active');
  });

  $('.kick-off-card input[type=radio]').on('change', function() {
      $('.kick-off-card').removeClass('checked');
      $(this).closest('.kick-off-card').addClass('checked');
  })

    const phoneInputs = document.querySelectorAll('.phone-number-js');
    phoneInputs.forEach(function(input) {
        function formatPhone(e) {
            let x = input.value.replace(/\D/g, '').slice(0, 10);
            let formatted = x;
            if (x.length > 6) {
                formatted = `(${x.slice(0,3)}) ${x.slice(3,6)}-${x.slice(6)}`;
            } else if (x.length > 3) {
                formatted = `(${x.slice(0,3)}) ${x.slice(3)}`;
            } else if (x.length > 0) {
                formatted = `(${x}`;
            }
            input.value = formatted;
        }
        input.addEventListener('input', formatPhone);
        formatPhone();
    });

});
